// Hebrew labels for the provenance values that appear in journal parameters, so
// the transparency page never shows an internal enum value.
const provenanceLabels = {
    canonical: 'מקור',
    historical: 'היסטורי',
    accepted_duplicate: 'כפילות מאושרת',
    rejected_duplicate: 'כפילות שנפסלה',
    missing: 'חסר',
}

function provenanceLabel(value) {
    return provenanceLabels[value] ?? value
}

// A user-facing Hebrew message per journal code. Codes that carry parameters
// interpolate them; the rest are static. Worded for the record's subject —
// never mentioning any internal detail such as a content hash.
const templates = {
    'entry:ready': () => 'הרשומה מוכנה לשידור',
    'entry:pending': () => 'הרשומה ממתינה לאישור',
    'entry:approved': () => 'הרשומה אושרה לשידור',
    'image:duplicate_image_accepted_via_override': () => 'תמונה כפולה אושרה ידנית',
    'image:duplicate_image_promoted_to_canonical': (params) =>
        `תמונה שסומנה כ${provenanceLabel(params.original_provenance)} הפכה למקור לאחר שהמקור הקודם נמחק`,
    'image:hash_backfilled': () => 'זהות התמונה נקבעה',
    'image:duplicate_image_excluded_from_batch': () => 'תמונה כפולה הוצאה מהשידור',
    'document:invalidated_and_excluded_from_batch': () => 'מסמך נפסל והוצא מהשידור',
    'entry:invalidated_and_excluded_from_batch': () => 'רשומה נפסלה והוצאה מהשידור',
    'batch:duplicate_in_batch': () => 'נמצאה כפילות בין רשומות באותו שידור',
}

// Journal codes that report something being kept out of a transmission. These read
// as errors on the transparency page; every other code is informational.
const errorTypes = new Set([
    'image:duplicate_image_excluded_from_batch',
    'document:invalidated_and_excluded_from_batch',
    'entry:invalidated_and_excluded_from_batch',
    'batch:duplicate_in_batch',
])

/**
 * The severity a journal record reads as: 'error' for the codes that report an
 * exclusion or invalidation, 'info' for everything else.
 */
export function journalSeverity(type) {
    return errorTypes.has(type) ? 'error' : 'info'
}

/**
 * Renders a journal record's Hebrew message from its `type` and `parameters`.
 * Falls back to the raw code when the type is unmapped.
 */
export function journalMessage({ type, parameters }) {
    const template = templates[type]
    if (template == null) {
        return type
    }

    const params = Object.fromEntries((parameters ?? []).map((parameter) => [parameter.name, parameter.value]))
    return template(params)
}
